/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

import { CardColorProps } from '../BaseIcon'

export const CashPay: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width={40} height={24} fill='#00D64F' rx={2} />
        <path
          fill='#F0F0F0'
          fillRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          clipRule='evenodd'
        />
        <path
          fill='#fff'
          fillRule='evenodd'
          d='M20.362 9.132c.855 0 1.675.346 2.21.822.136.12.338.12.465-.01l.637-.646a.332.332 0 0 0-.015-.484 5.035 5.035 0 0 0-1.708-.96l.2-.952a.334.334 0 0 0-.327-.402h-1.23a.334.334 0 0 0-.327.264l-.18.846c-1.637.082-3.024.899-3.024 2.574 0 1.45 1.148 2.072 2.36 2.502 1.147.43 1.752.59 1.752 1.196 0 .621-.605.988-1.498.988-.814 0-1.666-.269-2.328-.921a.332.332 0 0 0-.467-.001l-.685.675a.336.336 0 0 0 .003.48c.533.518 1.21.893 1.98 1.103l-.188.881a.334.334 0 0 0 .325.404l1.233.009a.333.333 0 0 0 .328-.265l.178-.848c1.96-.12 3.16-1.186 3.16-2.744 0-1.435-1.196-2.04-2.646-2.535-.83-.303-1.547-.51-1.547-1.13 0-.606.67-.846 1.34-.846Z'
          clipRule='evenodd'
        />
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <path
          fill='#F0F0F0'
          fillRule='evenodd'
          d='M38 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h36a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z'
          clipRule='evenodd'
        />
        <path
          fill='#797979'
          fillRule='evenodd'
          d='M20.362 9.132c.855 0 1.675.346 2.21.822.136.12.338.12.465-.01l.637-.646a.332.332 0 0 0-.015-.484 5.035 5.035 0 0 0-1.708-.96l.2-.952a.334.334 0 0 0-.327-.402h-1.23a.334.334 0 0 0-.327.264l-.18.846c-1.637.082-3.024.899-3.024 2.574 0 1.45 1.148 2.072 2.36 2.502 1.147.43 1.752.59 1.752 1.196 0 .621-.605.988-1.498.988-.814 0-1.666-.269-2.328-.921a.332.332 0 0 0-.467-.001l-.685.675a.336.336 0 0 0 .003.48c.533.518 1.21.893 1.98 1.103l-.188.881a.334.334 0 0 0 .325.404l1.233.009a.333.333 0 0 0 .328-.265l.178-.848c1.96-.12 3.16-1.186 3.16-2.744 0-1.435-1.196-2.04-2.646-2.535-.83-.303-1.547-.51-1.547-1.13 0-.606.67-.846 1.34-.846Z'
          clipRule='evenodd'
        />
      </React.Fragment>
    )}
  </React.Fragment>
)
